import React, { useState } from "react";
import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";
import { moveItem } from "../../../../utils/reorder";
import { BLOCK_TYPES } from "../../../../utils/constants";

export default function BlockList({
                                      fragment,
                                      selectedBlockId,
                                      onSelect,
                                      onChange,
                                      onDeleteRequest,
                                  }) {
    const [open, setOpen] = useState(false);

    if (!fragment) {
        return <div className="text-gray-500">اول یک فرگمنت انتخاب کن</div>;
    }

    const blocks = Array.isArray(fragment.blocks) ? fragment.blocks.filter(Boolean) : [];

    const addBlock = (type) => {
        const id = `${type}_${crypto.randomUUID().slice(0, 6)}`;
        let block;

        if (type === "text") {
            block = { id, type, config: { text: "" } };
        }

        if (type === "heading") {
            block = { id, type, config: { text: "", level: 2 } };
        }

        if (type === "image") {
            block = { id, type, config: { src: "", alt: "" } };
        }

        if (type === "question_single_choice") {
            block = {
                id,
                type,
                config: {
                    prompt: "",
                    options: [
                        { id: crypto.randomUUID(), text: "" },
                        { id: crypto.randomUUID(), text: "" },
                    ],
                    correctOptionId: null,
                },
            };
        }

        if (type === "question_multiple_choice") {
            block = {
                id,
                type,
                config: {
                    prompt: "",
                    options: [
                        { id: crypto.randomUUID(), text: "" },
                        { id: crypto.randomUUID(), text: "" },
                    ],
                    correctOptionIds: [],
                },
            };
        }

        if (type === "code") {
            block = {
                id,
                type,
                config: {
                    language: "python",
                    editable: true,
                    showCompiler: true,
                    code: "",
                },
            };
        }

        if (type === "placeholder_code") {
            block = {
                id,
                type,
                config: {
                    language: "python",
                    template: ["", ""],
                    placeholders: [{ key: "EXPR", mode: "code", starter: "" }],
                    showCompiler: true,
                },
            };
        }

        const next = [...blocks, block];
        onChange(next);
        onSelect(id);
        setOpen(false);
    };

    const move = (from, to) => onChange(moveItem(blocks, from, to));

    return (
        <div>
            <div className="flex items-center justify-between mb-3">
                <h2 className="font-bold">بلاک‌ها</h2>

                <div className="relative">
                    <button
                        onClick={() => setOpen((v) => !v)}
                        className="px-3 py-2 rounded-xl bg-blue-600 text-white text-sm flex items-center gap-2"
                    >
                        <Plus size={16} /> افزودن بلاک
                    </button>

                    {open && (
                        <div className="absolute right-0 mt-2 w-52 rounded-xl border bg-white shadow p-2 z-10">
                            {BLOCK_TYPES.map((t) => (
                                <button
                                    key={t.type}
                                    onClick={() => addBlock(t.type)}
                                    className="w-full text-right px-3 py-2 rounded-lg hover:bg-gray-50 text-sm"
                                >
                                    {t.label}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {blocks.length === 0 && (
                <div className="text-sm text-gray-500 p-3 rounded-xl border bg-white">
                    هنوز بلاکی نداری — از بالا «افزودن بلاک» بزن.
                </div>
            )}

            <div className="space-y-2 mt-3">
                {blocks.map((b, index) => (
                    <div
                        key={b.id}
                        className={`p-3 rounded-xl border ${
                            b.id === selectedBlockId
                                ? "bg-blue-50 border-blue-300"
                                : "bg-white border-gray-200"
                        }`}
                    >
                        <button onClick={() => onSelect(b.id)} className="w-full text-right">
                            <div className="font-medium">{b.id}</div>
                            <div className="text-xs text-gray-500">{b.type}</div>
                        </button>

                        <div className="flex justify-end gap-2 mt-2">
                            <button
                                disabled={index === 0}
                                onClick={() => move(index, index - 1)}
                                className="p-1 rounded hover:bg-gray-100 disabled:opacity-30"
                            >
                                <ArrowUp size={16} />
                            </button>

                            <button
                                disabled={index === blocks.length - 1}
                                onClick={() => move(index, index + 1)}
                                className="p-1 rounded hover:bg-gray-100 disabled:opacity-30"
                            >
                                <ArrowDown size={16} />
                            </button>

                            <button
                                onClick={() => onDeleteRequest(b.id)}
                                className="p-1 rounded hover:bg-red-50 text-red-600"
                            >
                                <Trash2 size={16} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
